import { MIME_TYPES } from "../constants";

/**
 @deprecated you should use download helpers from core-v2
 */
export class DownloadHelpers {
  /**
   * @param {string} file
   * @param {string} filenameWithExtension
   */
  static downloadFile(file, filenameWithExtension) {
    const downloadLinkTag = document.createElement("a");
    downloadLinkTag.href = file;
    downloadLinkTag.setAttribute("download", filenameWithExtension);
    document.body.appendChild(downloadLinkTag);
    downloadLinkTag.click();
    downloadLinkTag.remove();
  }

  /**
   * @param {string} base64
   * @param {string} filename
   * @param {string} extension
   */
  static downloadBase64Zip = (base64Data, filename, extension) => {
    // Make sure we have the correct base64 format (remove data URL prefix if present)
    const base64Content = base64Data.includes("base64,") ? base64Data.split("base64,")[1] : base64Data;

    // Convert base64 to binary
    const binaryData = atob(base64Content);

    // Create an array buffer from the binary data
    const byteArray = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i);
    }

    // Create a Blob from the array buffer
    const blob = new Blob([byteArray], { type: MIME_TYPES[extension] });

    // Create a link element to trigger the download
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename + "." + extension;

    // Append to the DOM, click and remove (to trigger the download)
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    // Clean up the object URL
    URL.revokeObjectURL(downloadLink.href);
  };
}
